import React, { useState } from 'react'
import { Box, TextField, TextareaAutosize } from '@mui/material'
import { FxLabel } from '../label/FxLabel'
import { FxTextAreaProps } from './FxTextArea.props'
import { FxValidation } from '../validation/FxValidation'

/**
 *
 * @param label
 * @param name
 * @param info
 * @param onValueChange
 * @param value
 * @param maxRows
 * @param minRows
 * @param placeholder
 * @param disabled
 * @param validations
 * @param validationResult
 * @param labelAlignment
 * @constructor
 */
export const FxTextArea = ({
  label,
  name,
  path,
  className,
  info,
  onValueChange,
  value,
  maxRows,
  minRows,
  placeholder,
  disabled = false,
  validations,
  validationResult,
  labelAlignment = 'top',
  variant = "outlined",
  fullWidth = false,
  textBoxLabel,

}: FxTextAreaProps) => {
  /**
   *
   * @param event
   */
  const onChange = (event: any) => onValueChange({ name, value: event.target.value, path })
  const [onBlur, setOnBlur] = useState(false)

  const isMandatory = () => {
    if (validations && validations.length > 0) {
      return validations.includes('required')
    }
  };

  const showTextBoxLbl = () => {
    if (isMandatory() && textBoxLabel) {
      return <>
        {textBoxLabel} <span className="text-danger">*</span>
      </>
    } else if(textBoxLabel){
      return <>{textBoxLabel}</>
    }
  }

  textBoxLabel = showTextBoxLbl()

  return (
    <>
      <div className={`fx-textarea ${labelAlignment == 'top' ? 'alignmentTop' : 'alignmentLeft'}`}>
        {label && <div><FxLabel info={info} label={label} validations={validations} /></div>}
        <TextField
          maxRows={maxRows}
          minRows={minRows}
          multiline
          className={className}
          label={textBoxLabel}
          name={name}
          value={value}
          onChange={onChange}
          variant={variant === "outlined" ? "outlined" : "standard"}
          disabled={disabled}
          fullWidth={fullWidth}
          placeholder={placeholder}
          onFocus={() => setOnBlur(false)}
          onBlur={() => setOnBlur(true)}
        />
        {/* <TextareaAutosize
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          // style={{borderBottom: "1px solid rgba(0, 0, 0, 0.42)", borderTop: "none", borderRight: "none", borderLeft: "none", outline: "none" }}
          style={{ color: "#495057", width: "100%" }}
        /> */}
      </div>
      <FxValidation
        name={name}
        value={value}
        validationResult={validationResult}
        validations={validations} />
    </>
  )
}
